export default "__VITE_ASSET__idgy$6IY__"